import { render, staticRenderFns } from "./SectionEmsReminder.vue?vue&type=template&id=70e7eb5a&scoped=true"
import script from "./SectionEmsReminder.vue?vue&type=script&lang=js"
export * from "./SectionEmsReminder.vue?vue&type=script&lang=js"
import style0 from "./SectionEmsReminder.vue?vue&type=style&index=0&id=70e7eb5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e7eb5a",
  null
  
)

export default component.exports